import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
    selector: "[roof-type-2]",
    templateUrl: "./roof-type-2.component.html",
    styleUrl: "./roof-type-2.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class RoofType2Component {
}
